import { render, staticRenderFns } from "./UpdateActionPlan.vue?vue&type=template&id=32825c6e"
import script from "./UpdateActionPlan.vue?vue&type=script&lang=js"
export * from "./UpdateActionPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports